import { render, staticRenderFns } from "./GroupBulkCreateModal.vue?vue&type=template&id=dbc3a530&scoped=true&"
import script from "./GroupBulkCreateModal.vue?vue&type=script&lang=js&"
export * from "./GroupBulkCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc3a530",
  null
  
)

export default component.exports